/**
 * Created by jv on 23/12/2016.
 */

import StorageController from "Sources/controllers/storage-controller";

const utils = require("Sources/utils/utils");
const GoogleAnalytics = {};
const TAG_ID = "G-2J8QRVHM3L";

$(function () {
  GoogleAnalytics.addScriptIfConsented();
});

(function (GoogleAnalytics) {
  GoogleAnalytics.hasConsented = function () {
    return String(StorageController.getCookie(StorageController.keys.COOKIEPOLIYCY_ANALYTICS_CONSENT)) === "true";
  };

  GoogleAnalytics.enable = function () {
    insertScriptTag();
  };

  GoogleAnalytics.disable = function () {
    removeScriptTag();
    removeGACookies();
  };

  GoogleAnalytics.addScriptIfConsented = function () {
    if (GoogleAnalytics.hasConsented()) {
      insertScriptTag();
    }
  };


  function insertScriptTag() {
    console.log("adding script")

    let script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + TAG_ID;
    $(script)[0].setAttribute("async", "");
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];

    function gtag() {
      window.dataLayer.push(arguments);
    }

    gtag('js', new Date());
    gtag('config', TAG_ID);

  }

  function removeScriptTag() {
    let $gaScriptEl = $("script[src='https://www.googletagmanager.com/gtag/js?id=" + TAG_ID + "']");
    $gaScriptEl.remove();
    if (!utils.isUndefined(window.dataLayer)) {
      window.dataLayer = window.dataLayer.filter(function (x) {
        return (x[0] !== "js") && (x[0] !== "config");
      });
    }
  }

  function removeGACookies() {
    StorageController.removeCookie("_ga");
    StorageController.removeCookie("_ga_" + TAG_ID);
    StorageController.removeCookie("_gid");
  }
}(GoogleAnalytics));

module.exports = GoogleAnalytics;



// WEBPACK FOOTER //
// ./app/js/misc/google-analytics.js